import {
    Box,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
} from '@mui/material';
import * as React from 'react';
import { Controller, useForm } from 'react-hook-form';
import pxToRem from 'assets/theme/function/px-to-rem';
import { initialListData } from 'pages/notification';
import { NotificationSystemListRequest } from 'types/notification/notification';
import CloseIcon from '@mui/icons-material/Close';
import {
    useNotificationGroupQuery,
    useNotificationIconNameQuery,
    useNotificationStatusQuery,
    useNotificationTypeQuery,
} from 'store/slices/notification/notification-enum';

interface Props {
    setDataNotificationRequestList?: React.Dispatch<
        React.SetStateAction<NotificationSystemListRequest>
    >;
}

const FilterNotificationSystem: React.FC<Props> = (props: Props) => {
    const { setDataNotificationRequestList } = props;
    const { handleSubmit, control, reset } =
        useForm<NotificationSystemListRequest>();

    const { data: notificationType } = useNotificationTypeQuery();
    const { data: notificationIconName } = useNotificationIconNameQuery();
    const { data: notificationGroup } = useNotificationGroupQuery();
    const { data: notificationStatus } = useNotificationStatusQuery();

    const onSubmit = (values: NotificationSystemListRequest) => {
        if (setDataNotificationRequestList) {
            setDataNotificationRequestList((prevState) => ({
                ...prevState,
                iconName: values.iconName,
                notificationGroup: values.notificationGroup,
                notificationCreationType: values.notificationCreationType,
                notificationType: values.notificationType,
                notificationStatus: values.notificationStatus,
            }));
        }
    };

    const resets = () => {
        reset();
        if (setDataNotificationRequestList) {
            setDataNotificationRequestList(initialListData);
        }
    };
    return (
        <Box
            pt={pxToRem(10)}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
            component="form"
            onSubmit={handleSubmit(onSubmit)}
        >
            <Box display={'flex'} flexBasis={'100%'}>
                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Icon Name</InputLabel>
                    <Controller
                        name="iconName"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                fullWidth
                                label="Icon Name"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Icon Name"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                        onChange(undefined)
                                                    }
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {notificationIconName?.map(
                                    (category, index) => (
                                        <MenuItem key={index} value={category}>
                                            {category}
                                        </MenuItem>
                                    ),
                                )}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Notification Type</InputLabel>
                    <Controller
                        name="notificationType"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                fullWidth
                                label="Icon Name"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Notification Type"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                        onChange(undefined)
                                                    }
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {notificationType?.map((category, index) => (
                                    <MenuItem key={index} value={category}>
                                        {category}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Notification Group</InputLabel>
                    <Controller
                        name="notificationGroup"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                fullWidth
                                label="Icon Name"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Notification Group"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                        onChange(undefined)
                                                    }
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {notificationGroup?.map((category, index) => (
                                    <MenuItem key={index} value={category}>
                                        {category}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>

                <FormControl sx={{ ml: pxToRem(10), width: '30%' }}>
                    <InputLabel>Notification status</InputLabel>
                    <Controller
                        name="notificationStatus"
                        control={control}
                        render={({ field: { name, value = '', onChange } }) => (
                            <Select
                                label="Notification status"
                                name={name}
                                value={value}
                                onChange={onChange}
                                input={
                                    <OutlinedInput
                                        label="Notification status"
                                        endAdornment={
                                            value && (
                                                <IconButton
                                                    size="small"
                                                    onClick={() =>
                                                        onChange(undefined)
                                                    }
                                                    sx={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        right: 25,
                                                        transform:
                                                            'translateY(-50%)',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            )
                                        }
                                    />
                                }
                            >
                                {notificationStatus?.map((status, index) => (
                                    <MenuItem key={index} value={status}>
                                        {status}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
            </Box>

            <Box display={'flex'} alignItems={'center'} ml={pxToRem(20)}>
                <Button
                    sx={{ mr: pxToRem(20), px: pxToRem(20) }}
                    variant={'contained'}
                    type={'submit'}
                >
                    Search
                </Button>
                <Button
                    sx={{ px: pxToRem(20) }}
                    variant={'contained'}
                    color={'secondary'}
                    onClick={resets}
                >
                    Clear
                </Button>
            </Box>
        </Box>
    );
};

export default FilterNotificationSystem;
